import _classCallCheck from "D:\\Work\\Raak\\Projects\\mcleods\\419_mcleods\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\Work\\Raak\\Projects\\mcleods\\419_mcleods\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "D:\\Work\\Raak\\Projects\\mcleods\\419_mcleods\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "D:\\Work\\Raak\\Projects\\mcleods\\419_mcleods\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "D:\\Work\\Raak\\Projects\\mcleods\\419_mcleods\\node_modules\\@babel\\runtime/helpers/esm/assertThisInitialized";
import _inherits from "D:\\Work\\Raak\\Projects\\mcleods\\419_mcleods\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React from 'react';
import PropTypes from 'prop-types'; // eslint-disable-line import/no-extraneous-dependencies

var MouseTooltip =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(MouseTooltip, _React$PureComponent);

  function MouseTooltip() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, MouseTooltip);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(MouseTooltip)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      xPosition: 0,
      yPosition: 0,
      mouseMoved: false,
      listenerActive: false
    });

    _defineProperty(_assertThisInitialized(_this), "getTooltipPosition", function (_ref) {
      var xPosition = _ref.clientX,
          yPosition = _ref.clientY;

      _this.setState({
        xPosition: xPosition,
        yPosition: yPosition,
        mouseMoved: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "addListener", function () {
      window.addEventListener('mousemove', _this.getTooltipPosition);

      _this.setState({
        listenerActive: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "removeListener", function () {
      window.removeEventListener('mousemove', _this.getTooltipPosition);

      _this.setState({
        listenerActive: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "updateListener", function () {
      if (!_this.state.listenerActive && _this.props.visible) {
        _this.addListener();
      }

      if (_this.state.listenerActive && !_this.props.visible) {
        _this.removeListener();
      }
    });

    return _this;
  }

  _createClass(MouseTooltip, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.addListener();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.updateListener();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeListener();
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement("div", {
        className: this.props.className,
        style: _objectSpread({
          display: this.props.visible && this.state.mouseMoved ? 'block' : 'none',
          position: 'fixed',
          top: this.state.yPosition + this.props.offsetY,
          left: this.state.xPosition + this.props.offsetX
        }, this.props.style)
      }, this.props.children);
    }
  }]);

  return MouseTooltip;
}(React.PureComponent);

_defineProperty(MouseTooltip, "defaultProps", {
  visible: true,
  offsetX: 0,
  offsetY: 0
});

MouseTooltip.propTypes = {
  visible: PropTypes.bool,
  children: PropTypes.node.isRequired,
  offsetX: PropTypes.number,
  offsetY: PropTypes.number,
  className: PropTypes.string,
  style: PropTypes.object // eslint-disable-line react/forbid-prop-types

};
export default MouseTooltip;